// Reusable shimmer-bar spinner. Extracted from ConnectingModal so the
// SearchingModal (and any future "wait while server thinks" UI) can drop
// it in without re-defining the keyframe animation per consumer.

const STYLES_ID = 'spinner-styles';
const STYLES = `
.shimmer-spinner {
  width: 320px; height: 18px;
  background: rgba(255,255,255,0.18);
  border-radius: 9px;
  overflow: hidden;
}
.shimmer-spinner .bar {
  width: 35%; height: 100%;
  background: linear-gradient(90deg, transparent, #FA9C22, transparent);
  animation: shimmer-spinner-shimmer 1100ms linear infinite;
}
@keyframes shimmer-spinner-shimmer {
  0%   { transform: translateX(-90%); }
  100% { transform: translateX(290%); }
}
`;

export interface SpinnerOptions {
  /** Pixel width of the bar. Defaults to 320 to match ConnectingModal's
   *  long-since-shipped sizing. */
  width?: number;
}

/** Returns a fresh `<div class="shimmer-spinner">…</div>` element. Safe to
 *  call repeatedly — global stylesheet is added once on first call. */
export function makeSpinner(opts: SpinnerOptions = {}): HTMLElement {
  ensureStyles();
  const root = document.createElement('div');
  root.className = 'shimmer-spinner';
  if (opts.width != null) root.style.width = `${opts.width}px`;
  const bar = document.createElement('div');
  bar.className = 'bar';
  root.appendChild(bar);
  return root;
}

function ensureStyles(): void {
  if (document.getElementById(STYLES_ID)) return;
  const style = document.createElement('style');
  style.id = STYLES_ID;
  style.textContent = STYLES;
  document.head.appendChild(style);
}
